import { createFileRoute } from "@tanstack/react-router";

import { ProductFinderPanel } from "@/features/xapi/product-finder-panel";

export const Route = createFileRoute("/_authenticated/nikeapp/product-finder")({
  component: ProductFinderRoute,
});

function ProductFinderRoute() {
  return <ProductFinderPanel />;
}
